import { createPresets } from '@/layouts/dashboard/util'
import { InputDateRangePreset } from '@dashboard/ui'
import { create } from 'zustand'

type State = {
  presets: InputDateRangePreset[]
  selectedDateFilter: InputDateRangePreset | null
  versions: string[] | null
  setSelectedDateFilter: (val: InputDateRangePreset) => void
  setVersions: (val: string[] | null) => void
  getStartEndFilter: () => { start?: number; end?: number }
  closeFilters: () => void
}

export const useNodeAnalyticsStore = create<State>((set, get) => ({
  presets: [],
  selectedDateFilter: null,
  versions: null,
  setSelectedDateFilter: val => set({ selectedDateFilter: val }),
  closeFilters: () => set({ versions: null }),
  setVersions: val => {
    if (val) {
      if (!get().versions) {
        const presets = createPresets()
        set({ presets, selectedDateFilter: presets[4] })
      }
    }
    set({ versions: val })
  },
  getStartEndFilter: () => {
    const { selectedDateFilter } = get()
    if (!selectedDateFilter) {
      return { start: undefined, end: undefined }
    }
    const from = selectedDateFilter.range.from
    const to = selectedDateFilter.range.to
    return {
      start: from ? Math.round(from.getTime() / 1000) : undefined,
      end: to ? Math.round(to.getTime() / 1000) : undefined,
    }
  },
}))
